export default __webpack_public_path__ + "static/media/bp_komfort_prepaid.077db601.svg";